var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTopCenter = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24773 4.80176L21.1527 4.80176C21.612 4.80176 21.9844 4.42941 21.9844 3.97009V3.97009C21.9844 3.51078 21.612 3.13843 21.1527 3.13843L3.24773 3.13843C2.78865 3.13843 2.41607 3.51101 2.41607 3.97009C2.41607 4.42917 2.78865 4.80176 3.24773 4.80176Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4148 10.1333L11.4148 20.6996C11.4148 21.1967 11.8178 21.5996 12.3148 21.5996V21.5996C12.8119 21.5996 13.2148 21.1967 13.2148 20.6996L13.2148 10.1333L15.9148 10.1333L12.3148 6.54228L8.71484 10.1333L11.4148 10.1333Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTopCenter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/top-center.f1adbb73.svg";
export { ForwardRef as ReactComponent };